import React, { useContext } from 'react';
import { AddStorageDataContext } from 'context/AddStorageContext';
import { TicketApi } from 'services/ticket';
import { Circle } from 'sub_components/Common/Circle';
import { DATACENTER_LOCATIONS } from 'utils/CommonConstants';
import styled from 'styled-components';

const StorageLocationStyle = styled.div`
	.locations-wrapper {
		display: flex;
		flex-wrap: wrap;
		justify-content: center;

		.location {
			width: 65px;
			height: 65px;
			cursor: pointer;
			position: relative;
			margin-right: 17px;
			margin-left: 17px;
			margin-bottom: 20px;
			display: flex;
			flex-direction: column;
            justify-content:center;
            align-items:center;
			.location-title {
				white-space:nowrap;
			}
			img {
				position: absolute;
				top: 8px;
				left: 20px;
				width: 25px;
				height: 25px;
				border:none;
			}
			&.active {
				opacity: 1;
					circle {
						fill: #ffffff;
					}
			}
		}
	}

	@media screen and (min-width: ${props => props.theme.res.medium}) and (max-width: ${props =>
	props.theme.res.high}) {
		.locations-wrapper {
			display: flex;
			flex-wrap: wrap;
			justify-content: center;
	
			.location {
				width: 75px;
				height: 75px;
				cursor: pointer;
				position: relative;
				margin-right: 30px;
				margin-bottom: 30px;
				display: flex;
				flex-direction: column;
				justify:content;center;
				align-items:center;
				.location-title {
				}
				&.six{
					img{
						width:20px;
						height:20px;
						top: 17px;
						left: 27px;
						
					}
				}
				img {
					position: absolute;
					top: 12px;
					left: 22px;
					width: 30px;
					height: 30px;
					border:none;
				}
				&.active {
					opacity: 1;
						circle {
							fill: #ffffff;
						}
				}
			}
		}
	}
	@media screen and (min-width: ${props => props.theme.res.high}) {
		.locations-wrapper {
			
	
			.location {
				width: 125px;
				height: 125px;
				margin-right: 40px;
				margin-bottom: 40px;

				&.six{
					img{
						width:25px;
						height:25px;
						top: 37px;
						left: 48px;	
					}
				}
				
				img {
					position: absolute;
					top: 28px;
					left: 40px;
					width: 40px;
					height: 40px;
					border:none;
				}
				&.active {
					opacity: 1;
						circle {
							fill: #ffffff;
						}
				}
			}
		}
	}
`;

function isSelected(location, selectedLocations) {
	if (!selectedLocations) {
		return false;
	}

	if (selectedLocations.includes(location?.location)) {
		return true;
	} else {
		return false;
	}
}

function filterLocations(activePageIndex, inputs) {
	let locations = DATACENTER_LOCATIONS;

	if (activePageIndex !== 2 && inputs?.primaryLocation) {
		locations = locations.filter(location => location?.location !== inputs?.primaryLocation);
	}
	return locations;
}

export const ShareLocationScreen = ({ activePageIndex }) => {
	const { inputs, change } = useContext(AddStorageDataContext);

	const filteredLocations = filterLocations(activePageIndex, inputs);

	function updateLocations(location) {
		if (activePageIndex === 2) {
			change({ target: { name: 'primaryLocation', value: location } });
		} else {
			change({ target: { name: 'secondaryLocation', value: location } });
		}
	}
	const selectedInput = activePageIndex === 2 ? inputs?.primaryLocation : inputs?.secondaryLocation;

	return (
		<StorageLocationStyle>
			<div className='data-center-screen-locations'>
				<div className='locations-wrapper'>
					{filteredLocations.map(location => (
						<div
							id={location.key}
							className={
								isSelected(location, selectedInput)
									? `location ${location.key} active`
									: `location ${location.key}`
							}
							onClick={() => updateLocations(location?.location)}
							data-cy={`location-${location.location}`}
						>
							<Circle location={location.location} />
							<img src={TicketApi.getSmallBuildingIcons(location.location)} />
							<div className='location-title body10'>{location?.location}</div>
						</div>
					))}
				</div>
			</div>
		</StorageLocationStyle>
	);
};
